import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Stack,
  Button,
} from '@mui/material';
import { Person, StringType, Racquet } from '../types';

type Step = 'person' | 'racquet' | 'mains' | 'crosses' | 'details';

interface Props {
  person?: Person;
  racquet?: Racquet;
  mains?: StringType;
  crosses?: StringType;
  mainsTension?: number | null;
  crossesTension?: number | null;
  date?: string;
  feedback?: string;
  onEditStep?: (step: Step) => void;
}

export default function FormSummary({
  person,
  racquet,
  mains,
  crosses,
  mainsTension,
  crossesTension,
  date,
  feedback,
  onEditStep,
}: Props) {
  const renderRow = (label: string, value?: string | number | null) =>
    value !== undefined && value !== null && value !== '' ? (
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" fontWeight="600" fontSize='0.875rem' color='text.secondary' sx={{ minWidth: 120 }}>
          {label}
        </Typography>
        <Typography variant="body2">{value}</Typography>
      </Box>
    ) : null;

  const section = (
    title: string,
    children: React.ReactNode,
    editStep: Step
  ) => (
    <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
      <Stack flexDirection='row' justifyContent='space-between' alignItems='flex-start'>
        <Typography variant="subtitle2" fontWeight="600" fontSize='1rem' color='text.secondary' mb={2} textTransform='uppercase'>
          {title}
        </Typography>
        {onEditStep && (

          <Button variant="text" size="small" onClick={() => onEditStep(editStep)}
            aria-label={`Edit ${title}`}>
            Edit
          </Button>
        )}
      </Stack>
      <Box>{children}</Box>
    </Paper>
  );

  return (
    <Box mb={3}>
      {person &&
        section(
          'Person',
          [
            renderRow('First name', person.firstName),
            renderRow('Last name', person.lastName),
            person.preferences ? (
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" fontWeight="600" fontSize='0.875rem' color='text.secondary' sx={{ minWidth: 120 }}>
                  Preferences
                </Typography>
                <Box
                  sx={{ fontSize: '0.875rem', lineHeight: 1.4 }}
                  dangerouslySetInnerHTML={{ __html: person.preferences }}
                />
              </Box>
            ) : null,
          ],
          'person'
        )}
      {racquet &&
        section(
          'Racquet',
          [
            renderRow('Brand', racquet?.brand),
            renderRow('Model', racquet?.model)
          ],
          'racquet'
        )}


      {mains &&
        section(
          'Mains String',
          [
            renderRow('Brand', mains.brand),
            renderRow('Name', mains.name),
            renderRow('Tension (lbs)', mainsTension),
          ],
          'mains'
        )}

      {(crosses || crossesTension !== undefined) &&
        section(
          'Crosses String',
          [
            crosses ? renderRow('Brand', crosses.brand) : null,
            crosses ? renderRow('Name', crosses.name) : null,
            renderRow('Tension (lbs)', crossesTension),
          ],
          'crosses'
        )}
    </Box>
  );
}
